import React from 'react';
import EnumValueToText from 'components/base/EnumValueToText';
import { Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

interface IProps {
  enums: any;
  value: any;
}

const PRTimeLimit: React.FC<IProps> = (props) => {
  const { enums, value } = props || {};

  const type = value?.type;

  return (
    <>
      {type ===1 && <EnumValueToText value={type} enums={enums} nameSpace='p_r_time_limit_type' />}
      {type !== 1 && (
        <>
          <div style={{ lineHeight: '32px' }}><EnumValueToText value={type} enums={enums} nameSpace='f_time_limit_tip_text' />：</div>
          { (value?.time_range || []).join(' 至 ') }
        </>
      )}
    </>
  );
};

export default PRTimeLimit;